module.exports = __webpack_public_path__ + "static/media/logo-store.0dcb2462.png";